module.exports = __webpack_public_path__ + "img/1.448a03fe.jpg";